export const updateQueryParams = (params, replace = false) => {
  const url = new URL(window.location);

  Object.entries(params).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') {
      url.searchParams.set(key, value);
    } else {
      url.searchParams.delete(key);
    }
  });

  if (replace) {
    history.replaceState({}, '', url.toString());
  } else {
    history.pushState({}, '', url.toString());
  }
};

export const removeUrlParams = (paramNames, replace = false) => {
  const url = new URL(window.location);

  paramNames.forEach((param) => {
    url.searchParams.delete(param);
  });

  if (replace) {
    history.replaceState({}, '', url.toString());
  } else {
    history.pushState({}, '', url.toString());
  }
};

export const getCurrentSearchParams = () => {
  return Object.fromEntries(new URLSearchParams(window.location.search));
};

export const removeTurbolinksHistory = () => {
  window.history.replaceState(
    {},
    '',
    window.location.pathname + window.location.search
  );
};
